// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"15":"a92e3849","194":"ae5a7e9a","682":"30b00ee1"}[chunkId] + ".css";
};